import { Put } from '../helpers';
import { EventGroup } from '@/types/projects.types';

export function UpdateProjectGroup(
  channel: number,
  groupUuid: string,
  name: string,
  projectUuids: string[],
  adminIds: number[]
): Promise<EventGroup> {
  return Put({
    path: `/v3/admin/channel/${channel}/event-groups/${groupUuid}`,
    body: { name, eventUuids: projectUuids, adminIds },
  });
}
